import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { maschinentypenSelector, maschinentypenByNrSelector } from 'store/lookups/selector';

interface MaschinentypeProps {
    label?: string;
    placeholder?: string;
    disabled: boolean;
    value: number;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: number) => void;
}

export const Maschinentype: React.FC<MaschinentypeProps> = ({
    label,
    placeholder,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const maschinentypen = useSelector(maschinentypenSelector);
    const maschinentypenByNr = useSelector(maschinentypenByNrSelector);

    const options = React.useMemo(() => {
        const o = maschinentypen
            .sort((a, b) => b.name.localeCompare(b.name))
            .map((a) => ({
                value: a.nr.toString(),
                label: a.name,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [maschinentypen, allowEmpty]);

    return (
        <>
            {label && <Label>{label}</Label>}
            <Select
                name={label ?? placeholder ?? ''}
                placeholder={placeholder}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: maschinentypenByNr[value]?.name || value.toString(),
                          }
                        : {
                              value: '',
                              label: placeholder ?? '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(parseInt(option?.value || '0', 10));
                }}
            />
        </>
    );
};
